var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext, useRef } from 'react';
import { Pressable } from 'react-native';
import { StateConfigContext } from '../../providers';
import { getTestId } from '../../utils';
import { DynamicSvg } from '../dynamic-svg';
import { Notifier } from '../notifier';
import { Typography } from '../typography';
import { getTabFontTypes, getTabProps, getTabStyles } from './TabStyles';
export var Tab = forwardRef((props, ref) => {
  var stateContext = useContext(StateConfigContext);
  var tabProps = getTabProps(props, stateContext);
  var stylesBasedOnState = useRef({});
  var text = tabProps.text,
    selected = tabProps.selected,
    disabled = tabProps.disabled,
    controlState = tabProps.controlState,
    prefixIcon = tabProps.prefixIcon,
    prefixIconProps = tabProps.prefixIconProps,
    showNotifier = tabProps.showNotifier,
    notifierProps = tabProps.notifierProps,
    onTabPress = tabProps.onTabPress,
    style = tabProps.style,
    _tabProps$testID = tabProps.testID,
    testID = _tabProps$testID === void 0 ? 'Tab' : _tabProps$testID,
    restProps = __rest(tabProps, ["text", "selected", "disabled", "controlState", "prefixIcon", "prefixIconProps", "showNotifier", "notifierProps", "onTabPress", "style", "testID"]);
  var getTabContainerStyles = useCallback(event => {
    var styles = getTabStyles(tabProps, event);
    stylesBasedOnState.current = styles;
    return [styles.container, style];
  }, [tabProps]);
  return _jsx(Pressable, Object.assign({
    accessibilityRole: "tab",
    ref: ref
  }, restProps, {
    style: getTabContainerStyles,
    disabled: disabled || controlState === 'disabled',
    onPress: onTabPress
  }, getTestId(testID), {
    children: () => {
      return _jsxs(_Fragment, {
        children: [!!prefixIcon && _jsx(DynamicSvg, Object.assign({
          iconName: prefixIcon,
          color: stylesBasedOnState.current.icon.color
        }, prefixIconProps, {
          style: stylesBasedOnState.current.icon
        }, getTestId(testID, 'icon'))), !!text && _jsx(Typography, Object.assign({
          type: getTabFontTypes(selected),
          color: stylesBasedOnState.current.label.color,
          text: text,
          style: stylesBasedOnState.current.label
        }, getTestId(testID, 'text'))), showNotifier && _jsx(Notifier, Object.assign({}, notifierProps, {
          style: [stylesBasedOnState.current.notifier, notifierProps === null || notifierProps === void 0 ? void 0 : notifierProps.style]
        }, getTestId(testID, 'notifier')))]
      });
    }
  }));
});